import { styled } from '@spazious/dollhouse-theme';

import { FlexElement } from '../Flex/Flex.js';
import { Stack } from '../Stack/index.js';

export type MenuPanelElement = FlexElement;

export const MenuPanel = styled(Stack).withConfig({
  displayName: 'MenuPanel',
})`
  padding: var(--spacing-padding);
`;
